export enum GatewayType {
  Unknown = 'Unknown',
  Viewpoint = 'Viewpoint',
  IoTEdge = 'IoTEdge',
  IoTEdgeCluster = 'IoTEdgeCluster',
  NFC = 'NFC',
  ESPA = 'ESPA',
  BLEBeacon = 'BLEBeacon',
  IoTEdgeMediaServerGatewayCluster = 'IoTEdgeMediaServerGatewayCluster',
}
